function buildParams(params) {
  const result = [];

  Object.keys(params).forEach(i => {
    result.push(`${encodeURIComponent(i)}=${encodeURIComponent(params[i])}`);
  });

  return result.join('&');
}

export default function jsonpAdapter(config) {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script');
    let src = config.url;
    const time = new Date().getTime();
    if (config.params) {
      const params = buildParams(config.params);

      if (params) {
        src += (src.indexOf('?') >= 0 ? '&' : '?') + params;
      }
    }

    script.async = true;

    const { jsonp } = config;
    const old = window[jsonp];
    let isAbort = false;

    window[jsonp] = responseData => {
      window[jsonp] = old;

      if (isAbort) {
        return;
      }

      const response = {
        data: responseData,
        status: 200
      };

      resolve(response);
    };

    const additionalParams = {
      v: time
    };

    additionalParams[config.callbackParamName || 'callback'] = jsonp;

    src += (src.indexOf('?') >= 0 ? '&' : '?') + buildParams(additionalParams);

    script.onload = () => {
      if (!script.readyState || /loaded|complete/.test(script.readyState)) {
        script.onload = null;
        script.onreadystatechange = null;

        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }

        script = null;
      }
    };

    script.onreadystatechange = script.onload;

    if (config.cancelToken) {
      config.cancelToken.promise.then(cancel => {
        if (!script) {
          return;
        }

        isAbort = true;
        reject(cancel);
      });
    }

    script.src = src;

    document.head.appendChild(script);
  });
}
